import {
  styled,
  css,
  DSScaledColors,
} from 'app/pages/request-single-page/components-v4/theme';

export const BadgeWrapper = styled.div`
  ${({ theme }) => css`
    padding-block: ${theme.spacings.xs};
    padding-inline: ${theme.spacings.s};
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.xs};
    width: 100%;
    background-color: ${theme.colors.gray[50]};
    border-radius: ${theme.radiuses.xs};
  `}
`;

export const IconWrapper = styled.div<{
  $isMobile: boolean;
  $colorVariant: keyof DSScaledColors;
}>`
  ${({ theme, $isMobile, $colorVariant }) => css`
    padding: ${theme.spacings[$isMobile ? 's' : 'base']};
    background-color: ${theme.colors[$colorVariant][100]};
    border-radius: ${theme.radiuses.xs};
  `}
`;

export const DateInfoWrapper = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacings.s};
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.xs};
    width: 100%;
    border-radius: ${theme.radiuses.s};
    border: 1px solid ${theme.colors.gray[100]};
    box-shadow: ${theme.shadows.xs};
  `}
`;
